import { useState } from "react";
import AddCustomerModal from './AddCustomerModal';
import IndividualKYCForm from './IndividualKYCForm';
import CorporateKYBForm from './CorporateKYBForm';

function ScreeningTab() {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [customerType, setCustomerType] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  // Sample customer data
  const customers = [
    {
      id: "CUST-001",
      name: "Ahmed Al Mansoori",
      type: "Individual",
      nationality: "UAE",
      riskRating: "Low",
      onboardingDate: "2025-08-15",
      lastScreening: "2025-10-01",
      status: "Active",
      pepStatus: "Not a PEP",
      sanctionsStatus: "Clear"
    },
    {
      id: "CUST-002",
      name: "Marina Properties LLC",
      type: "Corporate",
      nationality: "UAE",
      riskRating: "Medium",
      onboardingDate: "2025-09-01",
      lastScreening: "2025-10-02",
      status: "Active",
      pepStatus: "Not a PEP",
      sanctionsStatus: "Clear"
    },
    {
      id: "CUST-003",
      name: "Sarah Johnson",
      type: "Individual",
      nationality: "UK",
      riskRating: "High",
      onboardingDate: "2025-09-20",
      lastScreening: "2025-10-03",
      status: "Under Review",
      pepStatus: "Related to PEP",
      sanctionsStatus: "Clear"
    }
  ];

  

// Handle customer type selection from modal
const handleSelectCustomerType = (type) => {
  setCustomerType(type);
  setShowAddCustomerModal(false);
  setShowCustomerForm(true);
  console.log(`Opening ${type} KYC/KYB form`);
};

// Handle successful form submission
const handleFormSuccess = (customerId, type) => {
  setShowCustomerForm(false);
  setCustomerType(null);
  alert(`${type} KYC submitted! Customer ID: ${customerId}\n\nRedirecting to Risk Assessment...`);
  // TODO: Navigate to risk scoring page
};

// Handle form close
const handleFormClose = () => {
  setShowCustomerForm(false);
  setCustomerType(null);
};

  const renderDashboard = () => (
    <div>
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Onboarding & Screening Dashboard</h2>
      
      {/* KPI Cards */}
      <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#1976d2", margin: 0 }}>125</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Total Customers</p>
        </div>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#4caf50", margin: 0 }}>118</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Active Customers</p>
        </div>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#ff9800", margin: 0 }}>7</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Under Review</p>
        </div>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#f44336", margin: 0 }}>2</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>High Risk</p>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: "flex", gap: 15, marginBottom: 30 }}>
        <button
          onClick={() => setActiveSection("onboarding")}
          style={{
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Customer Onboarding
        </button>
        <button
          onClick={() => setActiveSection("riskRating")}
          style={{
            backgroundColor: "#ff9800",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Customer Risk Rating
        </button>
        <button
          onClick={() => setActiveSection("screening")}
          style={{
            backgroundColor: "#9c27b0",
            color: "white",
            border: "none",
            padding: "12px 24px",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: 15,
            fontWeight: "bold"
          }}
        >
          Sanctions / PEP Screening
        </button>
      </div>

      {/* Recent Customers Table */}
      <h3 style={{ color: "#0d47a1", marginBottom: 15 }}>Recent Customers</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", background: "white", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <thead>
          <tr style={{ backgroundColor: "#0d47a1", color: "white" }}>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Customer ID</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Name</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Type</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Risk Rating</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "left" }}>Status</th>
            <th style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.id}>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{customer.id}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{customer.name}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{customer.type}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>
                <span style={{
                  backgroundColor: customer.riskRating === "Low" ? "#4caf50" : customer.riskRating === "Medium" ? "#ff9800" : "#f44336",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "12px",
                  fontSize: "13px"
                }}>
                  {customer.riskRating}
                </span>
              </td>
              <td style={{ border: "1px solid #ccc", padding: "12px" }}>{customer.status}</td>
              <td style={{ border: "1px solid #ccc", padding: "12px", textAlign: "center" }}>
                <button
                  onClick={() => setSelectedCustomer(customer)}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: 13
                  }}
                >
                  View Details
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderOnboarding = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Customer Onboarding</h2>
      
      {/* UPDATED: Opens choice modal instead of form directly */}
      <button
        onClick={() => setShowAddCustomerModal(true)}
        style={{
          backgroundColor: "#1976d2",
          color: "white",
          border: "none",
          padding: "12px 24px",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: 15,
          fontWeight: "bold",
          marginBottom: 20
        }}
      >
        + Add New Customer
      </button>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Onboarding Checklist</h3>
        <ul style={{ lineHeight: 2, color: "#555" }}>
          <li>✅ Collect customer identification documents (Emirates ID / Passport)</li>
          <li>✅ Verify customer address proof (Utility bill / Bank statement)</li>
          <li>✅ Conduct initial risk assessment based on customer profile</li>
          <li>✅ Screen against sanctions lists (UAE, UN, OFAC, EU)</li>
          <li>✅ Check PEP status and related persons</li>
          <li>✅ Obtain senior management approval for high-risk customers</li>
          <li>✅ Document all findings in customer file</li>
          <li>✅ Set periodic review schedule based on risk rating</li>
        </ul>
      </div>
    </div>
  );

  const renderRiskRating = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Customer Risk Rating</h2>
      
      <div style={{ display: "flex", gap: 20, marginBottom: 30 }}>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#4caf50", margin: 0 }}>95</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Low Risk Customers</p>
        </div>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#ff9800", margin: 0 }}>28</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>Medium Risk Customers</p>
        </div>
        <div style={{ flex: 1, background: "white", padding: 20, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
          <h3 style={{ color: "#f44336", margin: 0 }}>2</h3>
          <p style={{ color: "#666", margin: "5px 0 0 0" }}>High Risk Customers</p>
        </div>
      </div>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Risk Rating Criteria</h3>
        
        <h4 style={{ color: "#4caf50" }}>Low Risk (Score: 1-3)</h4>
        <ul style={{ lineHeight: 1.8, color: "#555", marginBottom: 20 }}>
          <li>UAE nationals with stable income</li>
          <li>Transparent business operations</li>
          <li>No adverse media or sanctions hits</li>
          <li>Transaction patterns consistent with business profile</li>
        </ul>

        <h4 style={{ color: "#ff9800" }}>Medium Risk (Score: 4-6)</h4>
        <ul style={{ lineHeight: 1.8, color: "#555", marginBottom: 20 }}>
          <li>Foreign nationals from moderate-risk jurisdictions</li>
          <li>Cash-intensive businesses</li>
          <li>Complex corporate structures</li>
          <li>Higher transaction volumes</li>
        </ul>

        <h4 style={{ color: "#f44336" }}>High Risk (Score: 7-10)</h4>
        <ul style={{ lineHeight: 1.8, color: "#555" }}>
          <li>Politically Exposed Persons (PEPs)</li>
          <li>Customers from high-risk jurisdictions (FATF grey/black list)</li>
          <li>Unclear source of wealth or funds</li>
          <li>Previous regulatory sanctions or adverse findings</li>
        </ul>
      </div>
    </div>
  );

  const renderScreening = () => (
    <div>
      <button
        onClick={() => setActiveSection("dashboard")}
        style={{
          backgroundColor: "#ccc",
          color: "#333",
          border: "none",
          padding: "8px 16px",
          borderRadius: "5px",
          cursor: "pointer",
          marginBottom: 20
        }}
      >
        ← Back to Dashboard
      </button>
      
      <h2 style={{ color: "#0d47a1", marginBottom: 20 }}>Sanctions & PEP Screening</h2>
      
      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: 20 }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Screening Summary</h3>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
          <div>
            <p><strong>Total Screenings Today:</strong> 12</p>
            <p><strong>Matches Found:</strong> 0</p>
            <p><strong>False Positives:</strong> 3</p>
          </div>
          <div>
            <p><strong>Last Screening:</strong> 2025-10-05 08:30 AM</p>
            <p><strong>Next Scheduled:</strong> 2025-10-05 06:00 PM</p>
            <p><strong>Database Last Updated:</strong> 2025-10-04</p>
          </div>
        </div>
      </div>

      <div style={{ background: "white", padding: 30, borderRadius: 8, boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
        <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Screening Lists Coverage</h3>
        
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f5f5f5" }}>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>List Name</th>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Type</th>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "left" }}>Last Updated</th>
              <th style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>UAE Local Terrorist List</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>Sanctions</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>2025-10-04</td>
              <td style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>
                <span style={{ color: "#4caf50", fontWeight: "bold" }}>✓ Active</span>
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>UN Consolidated List</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>Sanctions</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>2025-10-03</td>
              <td style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>
                <span style={{ color: "#4caf50", fontWeight: "bold" }}>✓ Active</span>
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>OFAC SDN List</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>Sanctions</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>2025-10-04</td>
              <td style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>
                <span style={{ color: "#4caf50", fontWeight: "bold" }}>✓ Active</span>
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>EU Sanctions List</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>Sanctions</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>2025-10-02</td>
              <td style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>
                <span style={{ color: "#4caf50", fontWeight: "bold" }}>✓ Active</span>
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>Global PEP Database</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>PEP</td>
              <td style={{ border: "1px solid #ddd", padding: "12px" }}>2025-10-04</td>
              <td style={{ border: "1px solid #ddd", padding: "12px", textAlign: "center" }}>
                <span style={{ color: "#4caf50", fontWeight: "bold" }}>✓ Active</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div style={{ padding: 20 }}>
      {activeSection === "dashboard" && renderDashboard()}
      {activeSection === "onboarding" && renderOnboarding()}
      {activeSection === "riskRating" && renderRiskRating()}
      {activeSection === "screening" && renderScreening()}

      {/* NEW: Add Customer Type Choice Modal */}
      <AddCustomerModal
        isOpen={showAddCustomerModal}
        onClose={() => setShowAddCustomerModal(false)}
        onSelectType={handleSelectCustomerType}
      />

      {/* Customer Form Modal (Placeholder - will be replaced with actual forms) */}
      {/* Individual KYC Form */}
{showCustomerForm && customerType === 'individual' && (
  <IndividualKYCForm
    onClose={handleFormClose}
    onSuccess={handleFormSuccess}
  />
)}



        {/* Corporate KYB Form (Real form) */}
      {showCustomerForm && customerType === 'corporate' && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: 20
          }}
        >
          {/* Let the form render its own card; we just provide the overlay */}
          <div style={{ width: "100%", maxWidth: 980, maxHeight: "90vh", overflow: "auto" }}>
            <CorporateKYBForm
              onClose={handleFormClose}
              onSuccess={handleFormSuccess}
            />
          </div>
        </div>
      )}


      {/* Customer Details Modal (unchanged) */}
      {selectedCustomer && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "10px",
            width: "700px",
            maxHeight: "80vh",
            overflow: "auto"
          }}>
            <button
              onClick={() => setSelectedCustomer(null)}
              style={{
                float: "right",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Close
            </button>
            
            <h3 style={{ color: "#0d47a1", marginBottom: 20 }}>Customer Details</h3>
            
            <div style={{ marginBottom: 20 }}>
              <p><strong>Customer ID:</strong> {selectedCustomer.id}</p>
              <p><strong>Name:</strong> {selectedCustomer.name}</p>
              <p><strong>Type:</strong> {selectedCustomer.type}</p>
              <p><strong>Nationality:</strong> {selectedCustomer.nationality}</p>
              <p><strong>Risk Rating:</strong> <span style={{ color: selectedCustomer.riskRating === "High" ? "#f44336" : "#4caf50" }}>{selectedCustomer.riskRating}</span></p>
              <p><strong>Status:</strong> {selectedCustomer.status}</p>
              <p><strong>Onboarding Date:</strong> {selectedCustomer.onboardingDate}</p>
              <p><strong>Last Screening:</strong> {selectedCustomer.lastScreening}</p>
            </div>

            <hr style={{ margin: "20px 0" }} />

            <h4 style={{ color: "#0d47a1" }}>Screening Results</h4>
            <p><strong>PEP Status:</strong> {selectedCustomer.pepStatus}</p>
            <p><strong>Sanctions Status:</strong> <span style={{ color: "#4caf50" }}>{selectedCustomer.sanctionsStatus}</span></p>
            
            <div style={{ marginTop: 20, padding: 15, backgroundColor: "#e3f2fd", borderRadius: 5 }}>
              <strong>Note:</strong> This is sample data for POC demonstration purposes.
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScreeningTab;